// Renders the airline logo from images.thetarzanway.com/media/airlines/<code>.png
// inside the design's .airline-logo box. Falls back to the IATA code in the
// same box when the image 404s — so unknown carriers still render cleanly.

import { useState } from "react";

interface Props {
  code: string;
  name?: string;
}

const BASE = "https://images.thetarzanway.com/media/airlines";

export function AirlineLogo({ code, name }: Props) {
  const [failed, setFailed] = useState(false);
  const upper = (code || "").toUpperCase();

  return (
    <div className="airline-logo" title={name || upper}>
      {failed || !upper ? (
        <span style={{ fontSize: 11, fontWeight: 700, color: "var(--ink-2)", letterSpacing: "0.02em" }}>
          {upper || "—"}
        </span>
      ) : (
        <img
          src={`${BASE}/${upper}.png`}
          alt={name || upper}
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
